"use strict";

define(['app', 'underscore'], function (app, _) {
  var CsrfCollection = app.Backbone.Collection.extend({
    initialize: function initialize() {
      var self = this;
      this.listenTo(this, 'all', function () {
        var data = {};

        _.each(self.toJSON(), function (model) {
          data[model.name] = model.token;
        });

        app.$.ajaxSetup({
          data: data
        });
      });
    }
  });
  return app.Backbone.Model.extend({
    defaults: {
      name: false,
      token: false
    },
    initialize: function initialize() {
      if (!app.csrf) app.csrf = new CsrfCollection([]);
      app.csrf.add(this);
    }
  });
});